import React from 'react'
import { PaymentTypeItem } from '../PaymentTypeItem'

export function ListPaymentTypes({ payments, creditNumber }) {
  return (
    <>
      {payments?.map((payment, index) => (
        <PaymentTypeItem
          key={`payment_type_${payment?.PaymentTypeId?.toLowerCase()}_${index}`}
          payment={payment}
          creditNumber={creditNumber}
        />
      ))}
    </>
  )
}
